<template>
  <div class="container mb-5">
    <b-row v-if="soleProprietorshipSuggestions.data.length === 15" class="search-box mt-5 ml-0">
      <div class="search-input">
        <b-col class="col-12">
          <h2 class="text-left">A megadott névre rendszerünk a megjeleníthető maximumnál több egyezést talált.</h2>
        </b-col>
        <b-col class="col-12 col-md-8 mt-4">
          <p class="description">
            Kérjük, amennyiben nem találja vállalkozását a lenti listában, használja az adószámos keresést!
          </p>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col class="col-12 col-md-4 mt-4">
              <b-form>
                <b-form-group>
                  <small class="form-text text-left text-muted tax-title"> Adószám első 8 számjegye </small>
                  <b-form-input
                    type="number"
                    placeholder="Adószám"
                    v-model="taxNumber"
                    @input="taxNumberCheck"
                    :state="isTaxNumberValid"
                    :class="{ 'input-error': !isTaxNumberValid }"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    <div class="error-box">
                      <div class="error-text" v-if="invalidTaxNumber">
                        A megadott keresési szempont alapján nem található egyéni vállalkozó a nyilvántartásban
                      </div>
                      <div class="error-text" v-else>
                        Formailag helytelen a megadott adószám.
                      </div>
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col class="col-12 col-md-3 mt-md-4">
              <b-button
                class="submit-button"
                type="submit"
                variant="primary"
                :disabled="!isTaxNumberValid || !taxNumber"
                @click.prevent="onTaxNumberSubmit"
              >
                Tovább
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </div>
    </b-row>
    <b-row class="text-left more-result-table-header mt-5 mb-2">
      <b-col cols="3" class="col-sm-2">Név</b-col>
      <b-col cols="4" offset-sm="1" class="col-sm-1 pl-2">Adószám</b-col>
      <b-col cols="5" offset-sm="2" class="pl-0">Cím</b-col>
    </b-row>
    <b-spinner class="mt-5" large v-if="soleProprietorshipSuggestions.data.length === 0"></b-spinner>
    <b-row
      v-for="(item, index) in soleProprietorshipSuggestions.data"
      :key="index"
      class="text-left more-result-table-row"
      @click="onSoleProprietorshipSearchSubmit(index)"
    >
      <b-col cols="3" class="name col-sm-2">{{ getTitleCaseString(item.name) }}</b-col>
      <b-col cols="4" offset-sm="1" class="col-sm-1"> {{ item.id }}</b-col>
      <b-col cols="5" offset-sm="2">{{ getTitleCaseString(item.address) }}</b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PublicSoleProprietorshipMoreResults',
  components: {},
  data() {
    return {
      searchTerm: '',
      pageNumber: 1,
      isTaxNumberValid: true,
      taxNumber: ''
    }
  },
  computed: {
    ...mapGetters([
      'isSearchCompany',
      'soleProprietorshipSuggestions',
      'getSoleProprietorshipSearchTerm',
      'selectedSoleProprietorship',
      'invalidTaxNumber'
    ])
  },
  methods: {
    fullName(value) {
      return `${value.first} ${value.last}`
    },
    taxNumberCheck() {
      this.$store.commit('setInvalidSoleProprietorshipTaxNumber', false)
      const taxNumberValidationPattern = RegExp(/^[0-9]{8}$/)
      this.isTaxNumberValid = taxNumberValidationPattern.test(this.taxNumber) || !this.taxNumber
    },
    async onTaxNumberSubmit() {
      const getSoleProprietorshipQueryParams = { value: this.taxNumber }
      await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)

      if (!this.invalidTaxNumber) {
        this.$router.push({
          path: 'sole-proprietorship-details',
          query: { taxnumber: this.selectedSoleProprietorship.tax_number }
        })
      } else {
        this.isTaxNumberValid = false
      }
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      return 'more-result-table-row'
    },
    async onInputChange() {
      let _this = this
      this.$store.commit('setMoreResultCount', 1)

      if (this.searchTerm.length >= 3) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async function() {
          await _this.$recaptchaLoaded()
          const recaptchaToken = await _this.$recaptcha('search')
          const searchQueryParams = { search: _this.searchTerm, limit: 15, recaptchaToken }

          _this.$store.dispatch('searchSoleProprietorship', searchQueryParams)
        }, 500)
      }
    },
    async onSoleProprietorshipSearchSubmit(index) {
      const getSoleProprietorshipQueryParams = { value: this.soleProprietorshipSuggestions.data[index].id }
      await this.$store.dispatch('getSoleProprietorship', getSoleProprietorshipQueryParams)
      this.$router.push({
        path: 'sole-proprietorship-details',
        query: { taxnumber: this.soleProprietorshipSuggestions.data[index].full_tax_number }
      })
    },
    getTitleCaseString(item) {
      return item
        .split(' ')
        .map(name => {
          const lowerCaseName = name.toLowerCase()
          return lowerCaseName.charAt(0).toUpperCase() + lowerCaseName.slice(1)
        })
        .join(' ')
    }
  },
  mounted() {
    if (this.isSearchCompany) {
      this.$router.push('/')
    }
    this.searchTerm = this.getSoleProprietorshipSearchTerm
    this.$store.commit('setMoreResultCount', 1)
    this.onInputChange()
  }
}
</script>

<style scoped>
.more-result-table-header {
  padding-left: 44px;
  padding-bottom: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #636e72;
}
.more-result-table-row {
  display: flex;
  align-items: center;
  border: 1px solid #dfe6e9;
  padding: 28px;
  margin-bottom: 8px;
  margin-left: 0px;
  box-shadow: 0px 2px 12px rgb(45 52 54 / 5%);
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #636e72;
  min-height: 120px;
}

.more-result-table-row:hover {
  cursor: pointer;
}

.name {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #00903c;
}

.more-results-button-box {
  margin-top: 28px;
  margin-bottom: 80px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #00903c;
}

.results-button {
  cursor: pointer;
}

.loading {
  color: #dddddd;
  cursor: not-allowed !important;
}
.input-error {
  border-color: var(--color-red) !important;
}
.error-box {
  display: flex;
  justify-content: flex-start;
}
.error-text {
  margin-top: 1.5px;
  margin-left: 2px;
}

.search-box {
  background: #f2f8fa;
}

.search-input {
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 24px;
  padding-right: 24px;
}

.description {
  text-align: left;
  font-size: 16px;
  line-height: 24px;
  color: #636e72;
}

.form-control.is-invalid {
  background-image: none !important;
  padding-right: 10px;
}
.form-control.is-valid {
  background-image: none !important;
  padding-right: 10px;
}

.tax-title {
  margin-left: 2px;
  height: 20px;
}

.submit-button {
  width: 100%;
  margin-top: 23px;
}
</style>
